import { motion, useInView } from 'motion/react';
import { PropsWithChildren, useRef } from 'react';
import styled from 'styled-components';
import { ANIMATION_CONFIG } from '../../../constants/animationConfig';

interface MotionScaleButtonProps extends PropsWithChildren {
  className?: string;
}

export const MotionScaleButton = ({
  className,
  children,
}: MotionScaleButtonProps) => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    amount: ANIMATION_CONFIG.scaleButton.amount,
  });
  return (
    <MotionScaleButtonWrapper
      className={className}
      ref={ref}
      initial={{ opacity: 0, scale: ANIMATION_CONFIG.scaleButton.scale }}
      animate={
        isInView
          ? { opacity: 1, scale: 1 }
          : { opacity: 0, scale: ANIMATION_CONFIG.scaleButton.scale }
      }
      transition={{ duration: ANIMATION_CONFIG.scaleButton.duration }}
    >
      {children}
    </MotionScaleButtonWrapper>
  );
};

const MotionScaleButtonWrapper = styled(motion.div)``;
